module.exports = __webpack_public_path__ + "static/header-photo@2x-ba283334b841380a3eb50c3c92dca1e1.jpg";